import { render, staticRenderFns } from "./GovFilter.vue?vue&type=template&id=0f198452"
import script from "./GovFilter.vue?vue&type=script&lang=js"
export * from "./GovFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports